module.exports = __webpack_public_path__ + "img/02030208.83151ca0.svg";